export enum EditMode {
    EDIT = 'EDIT',
    INVALID = 'INVALID',
    NOT = 'NOT',
    ITO_SAME_VERSION = 'ITO_SAME_VERSION'
}
